import { render, staticRenderFns } from "./FaqSearch.vue?vue&type=template&id=4d97dcaf&scoped=true&"
import script from "./FaqSearch.vue?vue&type=script&lang=js&"
export * from "./FaqSearch.vue?vue&type=script&lang=js&"
import style0 from "./FaqSearch.vue?vue&type=style&index=0&id=4d97dcaf&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d97dcaf",
  null
  
)

export default component.exports